import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import {
	CRow, CCol,
	CForm,CFormInput,CFormSelect,CInputGroup,CInputGroupText,CFormCheck,
		CFormTextarea,CButton,
	CCard,CCardHeader,CCardBody,CCardFooter,
	CImage,
	CLink,
	CTooltip,
	CDropdown,CDropdownToggle,CDropdownMenu,CDropdownItem,CDropdownDivider,
	CBadge,CSpinner,
} from '@coreui/react';
import CIcon from '@coreui/icons-react'
//import NumberFormat from 'react-number-format';
import { isMobile } from "react-device-detect";
import {
	MyPagination,
	MyDialogform,
} from '../components/index'
import { Konfirm } from '../helpers/onConfirm'
import { UFunc } from '../helpers/functions'

const pjson 	= require('../../package.json')
const Rekapnota	= (props) => {
	const {
		setLoading,showToast,prosesExpired,setSessionaktif
	} = props; 

	//--DOM--/
	const uNavigate 				= useNavigate();
	const uDispatch 				= useDispatch();
	//--END DOM--/

	const uBahasaObj  				= useSelector(state => state.listBahasa);
	const uActiveroute  			= useSelector(state => state.activeRoute);
	const uSettingObj 				= useSelector(state => state.gListUserSetting);
	const uEfekapp					= useSelector(state => state.effectApp);
	const uConfigappsObj			= useSelector(state => state.uConfigappsObj) || {}; 
	const uMaxData					= isMobile ? (uSettingObj.jml_mobile || 25) : 100;
	const uTokenObj					= JSON.parse(localStorage.getItem("token")||"{}");
	const uKeywordObj				= JSON.parse(localStorage.getItem("listkeyword")) || {};
	const uISDemoapp				= uConfigappsObj.level_app === "DEMO";
	const uISHapusallow				= (uTokenObj.userhak==="FREEROLE"||uTokenObj.userhak==="ADMIN") && !uISDemoapp;
	const [uEfekview,setEfekview] 	= React.useState(false);
	const [uHtml500msg,setHtml500msg]	= React.useState(); 
	const [uTimeelapse,setTimeelapse]	= React.useState(0); 
	
	const uHeaderActionObj  		= useSelector(state => state.gInitHeaderAction);
	const uHandelView 				= uHeaderActionObj.isHeaderView || false;
	const uHandelTambah 			= uHeaderActionObj.isHeaderTambah || false;

	//--VIEWS_VARS--/
	const [uJmlData,setJmlData]			= React.useState(0);
	const [uPageActive,setPageActive]	= React.useState(1);
	const [uJmlHal,setJmlHal]			= React.useState(1);
	const [uDatamainArr,setDatamainArr]	= React.useState([]);
	const [uIdxRowselected,setIdxRowselected]= React.useState(-1);
	//--END VIEWS_VARS--/

	//--PAGING_DIATUR_BACKEND--/
	const uLastinitObj 					= useSelector(state => state.gInitTabelSelected);// || {};
	const [uInitselectedObj,setInitselectedObj] = React.useState({});
	//--PAGING_DIATUR_BACKEND--*/

	//--DLGLOOKUP--/
	//--END DLGLOOKUP--/

	//--DLGFORM--/
	const [uISDlgformshow,setDlgformshow]		= React.useState(false);
	const [uDlgformdataObj,setDlgformdataObj]	= React.useState({});
	//--END DLGFORM--/

	//--DLGVIEW--/
	//--END DLGVIEW--/

	//--DOM_VARS--/
	const uElJmlData			= document.getElementById("idjmldata");
	//--END DOM_VARS--/

	//--HANDEL--/
	const hdlKlikDlgsimpan = () => {}
	//--END HANDEL--/

	//--INIT_FUNC--/
	//--END INIT_FUNC--/

	//--CONTENT_FUNC--/
	const contentMain = () => {
		if(uHtml500msg) return "";

		const vMin			= (uPageActive-1)*uMaxData;
		const vMax			= (vMin+uMaxData);
		let vNumber			= vMin;
		const vKeyword 		= UFunc.filterRegex(uKeywordObj.kwd_pasien || "");
		const vKeywordcolor = uSettingObj.color_keyword || "#D725FF";
		const vReplace 		= new RegExp(vKeyword,"ig");

		//--PAGING_DIATUR_FRONTEND--/
		const vDataviewArr	= uDatamainArr.slice(vMin,vMax);
		//--END PAGING_DIATUR_FRONTEND--*/
		
		/*//--PAGING_DIATUR_BACKEND--/
		const vDataviewArr	= uDatamainArr.filter(vItems => 
			parseInt(vItems.page||1) === parseInt(uPageActive));
		//--END PAGING_DIATUR_FRONTEND--*/
		
		return (
		<table className="table table-borderless table-striped table-hover" id="idtabeldata">
		<thead>
			<tr className="d-none d-md-table-row text-center align-top classfontsmaller">
				<th width={35} className="px-1"><small>No</small></th>
			
				<th className="px-0">
				<CRow className="mx-0">
					<CCol md="2" className="px-1 text-start"><small>{uBahasaObj.caption_tglkunjungan||"Tgl Kunjungan"}</small></CCol>
					<CCol md="2" className="px-1">&middot;</CCol>
				</CRow>
				</th>
			</tr>

			<tr className="d-md-none classfontsmaller">
				<th width={30} className="p-0"/>
				<th className="p-0"/>
			</tr>
		</thead>

		<tbody>
		{vDataviewArr.map((vItems,vKeys) => {
			const {
				id,caption_pasien,
			} = vItems;

			vNumber++;
			const vCaptionUpper	= (caption_pasien||"").toUpperCase();

			const vPasiencaption	= vKeyword==="" ? (caption_pasien||"UNDF NAMA") 
				: (caption_pasien||"UNDF NAMA").replace(vReplace,"<b><u style='color:"+vKeywordcolor+"'>"+vKeyword.toUpperCase()+"</U></b>");

			return (
			<tr id={"idtr"+id} key={vKeys} className={"align-top text-end"+(uIdxRowselected===vKeys?" classrowselect":"")}>
				<td className="px-1">{vNumber}.</td>

				<td className="px-1 px-md-0">
				<CRow className="mx-0">
				<CCol md="2" className="px-1 text-md-start d-none d-md-block">
				</CCol>
				</CRow>
				</td>
			</tr>
			)
		})}
		</tbody>
		</table>
		)//>
	}
	const contentDlgform = () => {
		if(!uISDlgformshow) return (<></>)//>

		return (
		<CForm>
		</CForm>
		)//>
	}
	//--END CONTENT_FUNC--/

	//--API--/
	const apiLoaddata = (_PAGE) => {
		_PAGE	= parseInt(_PAGE)||1;//--PAGING_DIATUR_BACKEND--/
		setHtml500msg();

		const vKeyword 		= uKeywordObj.kwd_pasien || "";

		//--PAGING_DIATUR_FRONTEND--/
		setDatamainArr([]);
		setIdxRowselected(-1);
		setPageActive(1);
		//--END PAGING_DIATUR_FRONTEND--*/

		//--PAGING_DIATUR_BACKEND--/
		let vDatamainArr	= [...uDatamainArr];
		if(vKeyword.length < 3) {
			vDatamainArr 	= []
		} else {
			if(uDatamainArr.length >= 10000) {
				vDatamainArr	= vDatamainArr.filter(vItems=>parseInt(vItems.page||1) === 1);
			} else
				vDatamainArr	= vDatamainArr.filter(vItems=>parseInt(vItems.page||1) !== uPageActive);
		}
		//--END PAGING_DIATUR_BACKEND--*/
		setLoading(true);

		/*//--TESTING_FRONTEND--/
		let vTimeout = setTimeout(()=>{
		},2000); return
		//--END TESTING_FRONTEND--*/

		const vDATAS	= JSON.stringify({
			send_keyword : vKeyword,
			send_page: _PAGE,
			send_jmlperpage: uMaxData,
			send_loadjml: (JSON.stringify(uLastinitObj||{}) !== "{}") ? "YA" : "TIDAK",
			send_tokenauth : uTokenObj.userinit
		});
		const vURLs	= pjson.homepage+"api/api_pasien/ld_data";

		setTimeelapse(0);
		const vTimeBegin = new Date();
		fetch(vURLs,{
			headers: { Accept: "application/json", "Content-Type": "application/json" },
			method: "POST",
			mode: "cors",
			cache: "default",
			body: vDATAS,
		}).then((response)=> { if (response.status === 200){setSessionaktif(false); return response.json(); }})
		.then((output_string) => {
			setSessionaktif(true);
			setLoading(false);
			if(output_string.tampil) {
				//console.log("(Pasien - apiLoaddata) uPageActive : "+(uPageActive));
				const vTmpArr = JSON.parse(output_string.dataobject||"[]");
				
				//--PAGING_DIATUR_FRONTEND--/
				//--END PAGING_DIATUR_FRONTEND--*/

				//--PAGING_DIATUR_BACKEND--/
				if(vKeyword.length >= 3)
					setJmlData(parseInt(output_string.total_data||uJmlData))
				else setJmlData(vTmpArr.length);

				setDatamainArr([...vDatamainArr,...vTmpArr]);
		    	if(JSON.stringify(uLastinitObj||{}) !== "{}") 
		    		setInitselectedObj(uLastinitObj);
				//--END PAGING_DIATUR_BACKEND--*/

				const vTimeEnd = new Date();
				const vTimeDiff = vTimeEnd - vTimeBegin; //in ms
				setTimeelapse(vTimeDiff);
			} else if(output_string.info) {
				setHtml500msg(output_string.info);
			} else if(output_string.errors) {
				console.log("(Pasien - apiLoaddata) output_string.errors : "+output_string.errors);
				const vMsg = (pjson.mydefault.environment==="development")
					? output_string.errors : pjson.mydefault.msgFetchError;
				setHtml500msg("<div class='text-danger'>"+vMsg+"</div>");
			} else if(output_string.expired) {
				setLoading(true); prosesExpired();
			}
		})
		.catch((error) =>{
			setLoading(false);
			console.log("(Pasien - apiLoaddata) catch-error : "+error);
			setHtml500msg(pjson.mydefault.msg500str.join(" "));
		});
	}
	//--END API--/

	React.useEffect(()=>{
		uDispatch({type: "set", effectApp: !uEfekapp});
		uDispatch({type: "set", gUrlbefore: window.location.pathname + window.location.search});

    	//const vPageinit	= uPageActive;
		//console.log("(Pasien - []) uLastinitObj.initPage => "+(uLastinitObj.initPage))

		//--PAGING_DIATUR_FRONTEND--/
		apiLoaddata();
		//--END PAGING_DIATUR_FRONTEND--*/

		/*//--PAGING_DIATUR_BACKEND--/
		if(JSON.stringify(uLastinitObj||{}) !== "{}") {
			setPageActive(uLastinitObj.initPage||1);
			apiLoaddata(uLastinitObj.initPage||1);
		}
		//--END PAGING_DIATUR_BACKEND--*/

    	return () => {
			uDispatch({type: "set", gInitHeaderAction: {}});
			setDlgformshow(false);
    		setDatamainArr([]); setInitselectedObj({});
			setIdxRowselected(-1); setPageActive(0);
    	}
	},[]);
	//--PAGING_DIATUR_FRONTEND--/
	React.useEffect(()=>{ 
		setJmlData(uDatamainArr.length);
	},[uDatamainArr.length])
	//--END PAGING_DIATUR_FRONTEND--/
	React.useEffect(()=>{ 
		let vJmlHal	= Math.ceil(uJmlData / uMaxData);
		setJmlHal(vJmlHal);//-*/

		//--PAGING_DIATUR_BACKEND--/
		const vKeyword 		= uKeywordObj.kwd_pasien || "";
		if(vKeyword.length < 3) {
			uElJmlData && (uElJmlData.innerHTML = "&#8734;");
			return;
		}
		//--END PAGING_DIATUR_BACKEND--*/
		uElJmlData && (uElJmlData.innerHTML = UFunc.formatAngka(uJmlData));
	},[uElJmlData,uJmlData]);
	React.useEffect(()=>{ 
		//--PAGING_DIATUR_FRONTEND--/
		setIdxRowselected(-1);
		//--PAGING_DIATUR_FRONTEND--*/

		//--PAGING_DIATUR_BACKEND--/
    	if(JSON.stringify(uLastinitObj||{}) !== "{}") return;
    	if(uPageActive <= 0) { setPageActive(1); return }

		setIdxRowselected(-1); 
		const vDataviewArr	= uDatamainArr.filter(vItems=>parseInt(vItems.page||1) === parseInt(uPageActive));
		if(vDataviewArr.length > 0) {
			window.scrollTo({ top: 0, behavior: "smooth" });
			return;
		}
		apiLoaddata(uPageActive);
		//--END PAGING_DIATUR_BACKEND--*/
	},[uPageActive])
	//--PAGING_DIATUR_BACKEND--/
	React.useEffect(()=>{
		if(JSON.stringify(uInitselectedObj||{}) === "{}") return;

		const vIdxRow	= UFunc.getTabelRowIndeks("idtabeldata","idtr"+(uInitselectedObj.initID||0));
		setIdxRowselected(vIdxRow);

		uDispatch({type: "set", gInitTabelSelected: undefined});
		setInitselectedObj({});
		
		let vTimeout = setTimeout(()=>{
			clearTimeout(vTimeout);

			const vElscroll		= document.getElementById("idtr"+(uInitselectedObj.initID||"0"));
			const vRectdimensi 	= vElscroll && (vElscroll.getBoundingClientRect());
			
			vRectdimensi && (window.scrollTo({ top: (vRectdimensi.top||0) - 150, behavior: "smooth" }))
		},350);
	},[uInitselectedObj])
	//--END PAGING_DIATUR_BACKEND--*/
	React.useEffect(()=>{
		if(!uHandelView) return;

		uHeaderActionObj.isHeaderView = false;
		uDispatch({type: "set", gInitHeaderAction: uHeaderActionObj});

		//--PAGING_DIATUR_FRONTEND--/
		apiLoaddata();
		//--END PAGING_DIATUR_FRONTEND--*/

		//--PAGING_DIATUR_BACKEND--/
		setDatamainArr([]);
		setJmlData(0);
		setIdxRowselected(-1);

		if(parseInt(uPageActive) !== 1) {
			setPageActive(1);
		} else apiLoaddata();
		//--END PAGING_DIATUR_BACKEND--*/
	},[uHandelView])
	React.useEffect(()=>{
		if(!uHandelTambah) return;

		uHeaderActionObj.isHeaderTambah = false;
		uDispatch({type: "set", gInitHeaderAction: uHeaderActionObj});

		if(uHtml500msg) return;

	},[uHandelTambah])
	React.useEffect(()=>{
		if(!uISDlgformshow)
			{ setDlgformdataObj({}); return }
	},[uISDlgformshow])

	if(UFunc.isEmpty(uTokenObj)) { prosesExpired(); return ""; }
	if(uHtml500msg)  return (
		<CCard className="classbgcard">
		<CCardHeader>
		<b>{uBahasaObj.caption_page500||"Page 500"}</b>
		</CCardHeader>
		<CCardBody>{UFunc.renderHTML(uHtml500msg)}</CCardBody>
		</CCard>
	)//>

	return (
		<>
		<CCard className="classbgcard">
		<CCardHeader className="d-flex justify-content-between align-items-center">
			<div>
				<b className="align-middle">{uBahasaObj.caption_listdata||"List Data"}</b>
				<span className="mx-1 d-md-none">&middot;</span>
				<small className="d-md-none text-primary align-middle">{(()=>{
					const vKeyword = (uKeywordObj.kwd_pasien||"").trim();
					if(vKeyword.length < 3) return (<>&#8734;</>);

					return (<>[{UFunc.formatAngka(uJmlData)}]</>)
				})()}</small>
			</div>

			<span className="text-muted classfontsmaller">
				<small>{UFunc.formatAngka(uTimeelapse)}ms</small>
			</span>
			<small className="d-none">({uJmlData} - {uMaxData})</small>
		</CCardHeader>
		
		<CCardBody className="px-0">{contentMain()}</CCardBody>

		{(uJmlData > uMaxData) && (
		<CCardFooter>
			<MyPagination 
				activePage={uPageActive}
				pages={uJmlHal}
				onActivePageChange={(i)=>setPageActive(i)}
				align="start"/> 
		</CCardFooter>
		)}
		</CCard>

		<MyDialogform
			options={{size:(uDlgformdataObj.dlg_size||"lg"),centered:false}}
			onSimpan={()=>hdlKlikDlgsimpan()}
			show={uISDlgformshow} 
			dialogHeader={uDlgformdataObj.dlg_header}
			toggle={()=>setDlgformshow(false)}
			renderContent={contentDlgform()}/>
		</>
	)//>
}	

export default Rekapnota